(function () {
  'use strict';

  function normalize(text) {
    return (text || '')
      .toString()
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function initSection(root) {
    if (!root || root.dataset.nfReady === 'true') return;
    root.dataset.nfReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-nf-item]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-nf-chip]'));
    var search = root.querySelector('[data-nf-search]');
    var empty = root.querySelector('[data-nf-empty]');
    var activeCategory = 'all';
    var query = '';

    function closeItem(item) {
      var btn = item.querySelector('[data-nf-faq-btn]');
      var panel = item.querySelector('[data-nf-faq-panel]');
      item.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.hidden = true;
        panel.setAttribute('hidden', '');
      }
    }

    function openItem(item) {
      var btn = item.querySelector('[data-nf-faq-btn]');
      var panel = item.querySelector('[data-nf-faq-panel]');
      item.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-nf-faq-btn]');
      if (!btn) return;
      closeItem(item);
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (item.classList.contains('is-open')) closeItem(item);
        else openItem(item);
      });
    });

    function matchesFilters(item) {
      var category = item.getAttribute('data-nf-category') || 'genel';
      var searchable = normalize(item.getAttribute('data-nf-search') || '');
      var categoryOk = activeCategory === 'all' || category === activeCategory;
      var queryOk = !query || searchable.indexOf(query) !== -1;
      return categoryOk && queryOk;
    }

    function applyFilters() {
      var visibleCount = 0;
      items.forEach(function (item) {
        var show = matchesFilters(item);
        item.hidden = !show;
        item.style.display = show ? '' : 'none';
        if (!show) closeItem(item);
        else visibleCount += 1;
      });
      if (empty) empty.hidden = visibleCount > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeCategory = chip.getAttribute('data-nf-chip') || 'all';
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        query = normalize(search.value);
        applyFilters();
      });
    }

    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      var faq = event.target.closest('[data-nf-item]');
      if (!faq) return;
      openItem(faq);
      faq.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-nogag-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-nogag-faq]') ||
          (event.target.matches && event.target.matches('[data-nogag-faq]') ? event.target : null)
        : null;
    if (section) {
      section.dataset.nfReady = 'false';
      initSection(section);
    }
  });
})();
